/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IndividualDetailsViewModel } from './IndividualDetailsViewModel';
import {
    IndividualDetailsViewModelFromJSON,
    IndividualDetailsViewModelFromJSONTyped,
    IndividualDetailsViewModelToJSON,
} from './IndividualDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfIndividualDetailsViewModel
 */
export interface ResultOfIndividualDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfIndividualDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIndividualDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIndividualDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIndividualDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIndividualDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfIndividualDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfIndividualDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {IndividualDetailsViewModel}
     * @memberof ResultOfIndividualDetailsViewModel
     */
    data?: IndividualDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIndividualDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfIndividualDetailsViewModel interface.
 */
export function instanceOfResultOfIndividualDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfIndividualDetailsViewModelFromJSON(json: any): ResultOfIndividualDetailsViewModel {
    return ResultOfIndividualDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfIndividualDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIndividualDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : IndividualDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfIndividualDetailsViewModelToJSON(value?: ResultOfIndividualDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': IndividualDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

